import { render, staticRenderFns } from "./CourseDemo.vue?vue&type=template&id=1f071465"
import script from "./CourseDemo.vue?vue&type=script&lang=js"
export * from "./CourseDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports